export default __webpack_public_path__ + "512cfa9dc6cdc5bdc90868feb8acfd75.svg";